import React, { FC } from 'react';

import { CtaImageBox } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-index';

export const LandingMeetInPersonContainer: FC = () => {
    return (
        <CtaImageBox
            title={lexemes.lxPageIndexMeetInPersonTitle}
            description={lexemes.lxPageIndexMeetInPersonDescription}
            cta={{
                text: lexemes.lxPageIndexMeetInPersonCta,
                href: 'https://bumble.events/',
            }}
            image={{
                src: '/project-love/assets/meet-in-person.jpg',
                alt: lexemes.lxPageIndexMeetInPersonAlt,
            }}
            imagePosition="start"
        />
    );
};
